import React from 'react';
import { Col, Row, Button, Modal, ModalHeader, ModalBody, Table, Badge } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import AdminUploadResource from '../../components/admin/AdminUploadResource';
import AdminResourceGallery from '../../components/admin/AdminResourceGallery';
import LoadingCard from '../../components/LoadingCard';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useAmenityImageUpload } from './hooks/useAmenityImageUpload';

export const ModelAmenityUploadImages = () => {
    const {
        isLoading,
        sweetAlert,
        alertProps,
        projectAmenities,
        loadingStatuses,
        amenityImageStatus,
        handleOpenAmenityModal,
        handleCloseAmenityModal,
        showAmenityModal,
        selectedAmenityForImage,
        uploadAmenityImage,
        amenityImage,
        globalAlertOptions,
    } = useAmenityImageUpload();

    const pageName = `Actualizar imágenes de amenidades`;
    const pageParentName = `Preventa`;

    if (isLoading) return <LoadingCard name={pageName} parent_name={pageParentName} />;

    return (
        <AdminPage
            name={pageName}
            parentName={pageParentName}
            globalAlertOptions={globalAlertOptions}
        >
            {sweetAlert && (
                <SweetAlert {...alertProps}>
                    <div className="text-center" style={{ whiteSpace: 'pre-line' }}>
                        {alertProps.text}
                    </div>
                </SweetAlert>
            )}

            <Row className="mt-3">
                <Col md="12">
                    <h5>Estado de imágenes de amenidades</h5>
                    <Table className="align-items-center" responsive>
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">Amenidad</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingStatuses ? (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        Cargando estados...
                                    </td>
                                </tr>
                            ) : projectAmenities.length > 0 ? (
                                projectAmenities.map((amenity) => (
                                    <tr key={amenity.value}>
                                        <td>{amenity.label}</td>
                                        <td>
                                            <Badge
                                                color={
                                                    amenityImageStatus[amenity.value]
                                                        ? 'success'
                                                        : 'warning'
                                                }
                                            >
                                                {amenityImageStatus[amenity.value]
                                                    ? 'Con imagen'
                                                    : 'Sin imagen'}
                                            </Badge>
                                        </td>
                                        <td>
                                            <Button
                                                size="sm"
                                                color="primary"
                                                outline
                                                onClick={() => handleOpenAmenityModal(amenity)}
                                            >
                                                Gestionar imagen
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        No hay amenidades registradas en el proyecto
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Modal
                isOpen={showAmenityModal}
                toggle={handleCloseAmenityModal}
                size="lg"
            >
                <ModalHeader
                    toggle={handleCloseAmenityModal}
                >
                    Imagen - {selectedAmenityForImage?.label || ''}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <AdminUploadResource
                                handleUpload={uploadAmenityImage}
                                description={'Subir imagen'}
                                maxFiles={1}
                            />
                        </Col>
                        <Col>
                            <AdminResourceGallery
                                gallery={amenityImage ? [amenityImage] : []}
                                description={'Imagen actual'}
                            />
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </AdminPage>
    );
};

export default ModelAmenityUploadImages;